<template>
  <b-modal
    id="modal-material-type"
    :title="
      editTypeMaterial.id
        ? $t('reference.edit_vid_material')
        : $t('reference.add_vid_material')
    "
    cancel-variant="outline-secondary"
    :ok-title="editTypeMaterial.id ? $t('edit') : $t('save')"
    :ok-variant="editTypeMaterial.id ? 'warning' : 'success'"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmitMaterial"
  >
    <b-form>
      <validation-observer ref="materialTypeValidations">
        <b-tabs content-class="pt-1" fill>
          <b-tab active :title="$t('reference.name') + ' uz'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name') + ' uz'"
                rules="required"
              >
                <b-form-input v-model="material.title.uz" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>

          <b-tab :title="$t('reference.name') + ' ru'">
            <b-form-group :label="$t('reference.name')">
              <validation-provider
                #default="{ errors }"
                :name="$t('reference.name') + ' ru'"
                rules="required"
              >
                <b-form-input v-model="material.title.ru" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-tab>
        </b-tabs>
      </validation-observer>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "MaterialTypeModal",
  components: {
    BTabs,
    BTab,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    editTypeMaterial: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      material: {
        title: {
          uz: "",
          ru: "",
        },
        category: "",
      },
      // ===============  PRIMARY_DATA_SECTION END ===============



    };
  },
  watch: {
    // ===============  PRIMARY_WATCHERS_SECTION START ===============
    // ===============  PRIMARY_WATCHERS_SECTION END ===============
  },
  computed: {
    ...mapState("materials", ["product_categories"]),
  },
  mounted() {},
  methods: {
    ...mapActions("materials", [
      "CREATE_MATERIALS",
      "FETCH_MATERIALS",
      "UPDATE_MATERIALS",
    ]),





    // ===============  SHOW_MODAL_SECTION START ===============
    showModal() {
      this.material = {
        title: {
          uz: "",
          ru: "",
        },
        category: this.$route.params.category_id,
      };
      if (!this.editTypeMaterial || !this.editTypeMaterial.title) {
        return;
      }
      const { title, category, title_full } = this.editTypeMaterial;

      this.material = {
        title: {
          uz: title_full.uz,
          ru: title_full.ru,
        },
        category,
      };
    },
    // ===============  SHOW_MODAL_SECTION END ===============







    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmitMaterial(bvModalEvt) {
      bvModalEvt.preventDefault();

      await this.$refs.materialTypeValidations
        .validate()
        .then(async (success) => {
          if (!success) {
            this.$_errToast({message: this.$t('all_fields_are_required')});
            return;
          }
          try {
            if (this.editTypeMaterial.id) {
              await this.UPDATE_MATERIALS({
                id: this.editTypeMaterial.id,
                data: {
                  category: this.material.category.id,
                  title: this.material.title
                },
              });
            } else {
              await this.CREATE_MATERIALS(this.material);
            }

            this.$nextTick(() => {
              this.$bvModal.hide("modal-material-type");
            });

            this.material = {
              title: {
                uz: "",
                ru: "",
              },
              category: "",
            };

            this.$parent.refresh1();

            this.$_okToast();
          } catch (err) {
            console.log(err);
            // this.$_errToast('Error')
          }
        });
    },
    // ===============  ON_SUBMIT_SECTION END ===============
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
